<!--快递管理页面-->
<template>
<div class="page-box" ref="pageBox">
    <!--功能区域-->
    <ctrl-box class="ctrl-box" :data="{}" v-reheight="ctrlBoxHeightChanged">
        <el-link :underline="false" @click="getData(true)">
            <div class="wrap" >
                <icon-svg icon-class="icon-shuaxin1" font-size="27px;"/>
                <span class="txt" >{{msg('刷新')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="showQuery = !showQuery">
            <div class="wrap" >
                <icon-svg icon-class="icon-search" font-size="27px;"/>
                <span class="txt" >{{msg('搜索')}}</span>      
            </div>                 
        </el-link>
        <inventory-ctrl title="拒收" width="100px" icon="icon-quxiaohuifu">
            <template>
                <el-link class="ctrl-item" :underline="false" @click="doRefuse(1)">
                    <icon-svg icon-class="icon-quxiaohuifu" font-size="20px;"/>
                    <span class="txt">{{msg('拒收包裹')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="doRefuse(0)">
                    <icon-svg icon-class="icon-quxiaohuifu" font-size="22px;"/>
                    <span class="txt">{{msg('取消拒收')}}</span>
                </el-link>
            </template>
        </inventory-ctrl>
        <el-link :underline="false" @click="doExport()">
            <div class="wrap" >
                <icon-svg icon-class="icon-Excelbiaoge" style="color:#37C6B0;" font-size="27px;"/>
                <span class="txt" >{{msg('导出')}}</span>      
            </div>
        </el-link>
        <column-settings v-if="allColumns" @refresh-column="refreshColumn" col-key="INVENTORY_EXP_COLUMNS" :all-columns="allColumns"/>
        <!-- <el-link :underline="false" target="_blank" href="https://kdocs.cn/l/crla6ntoar7m">
            <div class="wrap" >
                <i class="el-icon-question" style="font-size:27px; color:#80DEEA; margin-bottom:3px;padding-top:5px;"/>
                <span class="txt" >{{msg('帮助')}}</span>      
            </div>                
        </el-link> -->
    </ctrl-box>
    <div class="empty-fixed-box" v-bind:style="{height:emptyFixedBoxHeight}"></div>
    <!--查询区域-->
    <transition name="el-zoom-in-top">
        <query-box :query="query" v-show="showQuery" labelWidth="80px">
            <template v-slot:default="scope">
                <el-form-item :label="msg('快递单号')">
                    <el-input size="mini" clearable v-model="scope.query.expCodes" type="textarea" ></el-input>
                </el-form-item>
                <el-form-item :label="msg('采购单号')">
                    <el-input size="mini" clearable v-model="scope.query.purchaseCodes" type="textarea" ></el-input>
                </el-form-item>
                <el-form-item :label="msg('采购状态')">
                    <el-select v-model="scope.query.status" multiple size="mini" clearable>
                        <el-option v-for="d in statuses" 
                            :key="d.value" :label="d.label" :value="d.value">
                        </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item :label="msg('到货仓库')">
                    <!-- <el-select v-model="scope.query.storeId" :placeholder="msg('请选择')" size="mini">
                        <el-option v-for="store in stores" :key="store.id" :label="store.name" :value="store.id"></el-option>
                    </el-select> -->
                    <el-input size="mini" clearable v-model="scope.query.storeName" ></el-input>
                </el-form-item>
                <el-form-item :label="msg('归属人')">
                    <el-input size="mini" clearable v-model="scope.query.creater" ></el-input>
                </el-form-item>
                <el-form-item :label="msg('归属公司')">
                    <el-input size="mini" clearable v-model="scope.query.ownerCompany" ></el-input>
                </el-form-item>
                <el-form-item :label="msg('录单时间')">
                    <el-date-picker clearable
                        v-model="scope.query.Date" value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="msg('签收时间')">
                    <el-date-picker clearable
                        v-model="scope.query.ReceiveDate" value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-row>
                    <el-button type="primary" icon="el-icon-search" @click="getData(true)" size="mini">{{msg('搜索')}}</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                </el-row>
            </template>
        </query-box>
    </transition>

    <!--表格区域-->
    <div class="table-wrap">
        <vxe-grid ref="dataTable" class="data-table" :height="docHeight"  
            resizable border="full"
            highlight-current-row highlight-hover-column highlight-current-column
            show-overflow show-header-overflow 
            :data="datas"
            size="mini"
            :columns="columns"
            @cell-click="clickRow"
            :export-config="exportConfig"
            :checkbox-config="{highlight:true, trigger: 'cell'}"
        ></vxe-grid>

        <pagenator @page-change="handlerPageChange" :query="query" >
        </pagenator>
    </div>

    <!-- 组件区域 -->
    <!--编辑库存-->
    <inventory-in-edit ref="InvinventoryInEditRef" @finish="getData"/>
    <inventory-in-trace ref="inventoryInTraceRef"/>
    <inventory-in-order-trace ref="inventoryInOrderTraceRef"/>
    <batch-update ref="batchUpdateRef" />
</div>
</template>

<script>
import Pagenator from "../../components/PaginationSimple.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import InventoryCtrl from "./InventoryCtrl.vue";
import ColumnSettings from "../../components/ColumnSettings.vue";
import QueryBox from "../../components/QueryBox.vue";
import InventoryInColumn from "./InventoryInColumn.js"
import {doDelete as deleteInventoryIn, syncExpCode} from "./InventoryInService.js"
import InventoryInEdit from "./InventoryInEdit.vue"
import InventoryInTrace from "./InventoryInTrace.vue"
import InventoryInOrderTrace from "./InventoryInOrderTrace.vue"
import InventoryInBatchUpdate from "./InventoryInBatchUpdate.vue";

const COL_KEY = "INVENTORY_EXP_COLUMNS";

export default {
    name: "inventory-express",
    components: {
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        InventoryCtrl:InventoryCtrl,
        QueryBox: QueryBox,
        InventoryInEdit: InventoryInEdit,
        InventoryInTrace: InventoryInTrace,
        ColumnSettings: ColumnSettings,
        BatchUpdate:InventoryInBatchUpdate,
        InventoryInOrderTrace:InventoryInOrderTrace
    },
    mounted: async function(){
        //初始化字段
        let savedCols =  [];
        this.allColumns = InventoryInColumn.allExpColumns;
        let savedColumnResult = await this.$axios.get(this.$kit.api.user.configs+"?groups="+COL_KEY);
        if(savedColumnResult && savedColumnResult.data[COL_KEY]){
            let savedColumns = JSON.parse(savedColumnResult.data[COL_KEY][0].xvalue);
            if(savedColumns){
                for(let key in savedColumns){ //{key: 1, key:0}
                    let checked = savedColumns[key] ? true: false;
                    let col = this.allColumns.find(i => i.field == key);
                    if(col && checked){
                        savedCols.push(col);
                    }
                }
            }
        }
        
        if(savedCols.length == 0){
            this.allColumns.forEach(c => {
                savedCols.push(c);
            })
        }
        
        this.columns = InventoryInColumn.buildColumns(this.$createElement, this, savedCols);
        //初始化状态
        this.statuses = this.dicts.inventoryInStatus;
        //初始仓储类型
        this.stores = this.getStores();

        let curr = new Date();
        let prevTime =  curr.getTime() - (7 * 24 * 3600 * 1000);
        let prev = new Date(prevTime);
        this.query.Date = [this.$kit.fmtDate(prev), this.$kit.fmtDate(curr)];

        //初始化列表
        this.getData();

        this.$nextTick(()=>{
            // 获取指定元素
            const scrollview = this.$refs['pageBox']
            scrollview.addEventListener('scroll', ()=>{
                // console.log("滚动中");
            }, true)

        });
    },
    data(){
        return {
            emptyFixedBoxHeight: '37px',
            query: {
                length: 20,
                start: 0,
                pageIndex:1,
                pageTotal: 0,

                expCodes: null,	//快递单号
                purchaseCodes: null,	//采购单号
                status: [],			//状态
                spec: null,				//规格
                inCode:null, //补货单号
                sku: null,				//sku
                variationSku: null,		//货号
                received: null,			//签收状态
                storeId: null,		//仓库id
                storeName: null,		//仓库名称
                creater: null,		//归属人
                companyName: null,		//归属公司
                title: null, //标题
                remark: null, // 备注
                remark1: null, // 说明
                origin:null, // 平台
                Date: [],           //创建时间
                ReceiveDate: [],         //签收时间
            },

            stores: [],
            statuses: [],  //状态列表
            showQuery: false,  //是否显示查询区域
            datas: null,
            columns: [],
            allColumns: null,
            exportConfig: {
                remote: false
            },
            options:[
                {label:'淘宝',value:'taobao'},
                {label:'1688',value:'alibaba'},
                {label:'拼多多',value:'pdd'},
            ],
        }
    },
    directives: {
        reheight: {
            bind(el, binding) {
                let height = '';
                function isReheight() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (height !== style.height) {
                        binding.value(style.height);
                    }
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReheight, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 260;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods: {
        //获取列表数据
        getData(refresh){
            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
                // this.selectedRows = [];
            }

            let param = this.$kit.rebuildQuery(this.query, ['Date', 'ReceiveDate']);
            if(param.expCodes){
                param.expCodes = param.expCodes.split(/[\r\n,]+/).filter(s => s);
            }
            if(param.purchaseCodes){
                param.purchaseCodes = param.purchaseCodes.split(/[\r\n,]+/).filter(s => s);
            }

            this.$axios.post(
                this.$kit.api.inventoryIn.expList, 
                param
            ).then((result) => {
                // this.$message(result.msg);
                if(result.status){
                    this.datas = result.data.list;
                    // this.query.pageTotal = result.data.total;
                }
            });
            this.$axios.request({
                    url: this.$kit.api.inventoryIn.expListTotal,
                    method: 'post',
                    data: param,
                    headers: {"Content-Type":"application/json; charset=utf-8",
                        "X-Requested-With":"XMLHttpRequest",
                    },
                    withCredentials: true,
                }).then((result) => {
                    if(result.status){
                        let total = result.data;
                        console.log("总条数为："+total);
                        this.query.pageTotal = total;
                    }
                });
        },
        ctrlBoxHeightChanged(height){
            this.emptyFixedBoxHeight = height;
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        getStores(){
            this.$axios.post(this.$kit.api.store.listUsed, {})
                .then( (result) => {
                    if(result.status){
                        let data = result.data;
                        data.splice(0, 0, {id: 0, name: '默认仓库'});
                        this.stores = data;
                    }
                });
        },
        //刷新列表字段
        refreshColumn(cols){
            this.columns = InventoryInColumn.buildColumns(this.$createElement, this, cols)
        },
        add(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$refs.InvinventoryInEditRef.showDialog(1, selectes.length>0?selectes[0]:null, this.stores);
        },
        edit(){
            this.callSelectedMethod((selectes)=>{
                this.$refs.InvinventoryInEditRef.showDialog(2, selectes[0], this.stores);
            });
        },
        closeEdit(refresh){
            if(refresh){
                this.getData();
            }
        },
        doDelete(){
            this.callSelectedMethod((selectes)=>{
                deleteInventoryIn(selectes, this.getData);
            });
        },
        //分页发生变化的回调函数
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            // this.selectedRows = [];
            this.getData();
        },
        clickRow({row,rowIndex, $event, column, columnIndex}){
            let className = $event.target.className;
            if(className.indexOf('status-cell')>-1){
                var table =  this.$refs.dataTable;
                table.clearCheckboxRow();
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))

                var selectes = this.$refs.dataTable.getCheckboxRecords();
                if(selectes.length>0){
                    let row = selectes[0];
                    this.$refs.inventoryInOrderTraceRef.showTracks(row.expCode);
                }

            }
        },
        //状态记录
        traces(){
            this.callSelectedMethod((selectes)=>{
                this.$refs.inventoryInTraceRef.showTracks(selectes[0].id, selectes[0].purchaseCodes , selectes[0].expCode);
            });
        },
        //快递同步
        updateExpCode(){
            this.callSelectedMethod((selectes)=>{
                syncExpCode(selectes, this.getData);
            });
        },
        //导出当前页面
        doExport(){
            this.$refs.dataTable.openExport({
                isPrint: false
            });
        },
        batchUpdate(){
            this.callSelectedMethod((selectes)=>{
                this.$refs.batchUpdateRef.showDrawer(
                    selectes.map(inv =>  {
                        return {id: inv.id, key:inv.expCode, value: null, label:null, result: null}
                    }),
                    this.stores
                );
            });
        },
        callSelectedMethod(callMethod){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }else{
                callMethod(selectes);
            }
        },
        formatOrigin({ cellValue }){
            let status = this.dicts.productOrigin.find(d => d.value === cellValue);
            return status.label || cellValue;
        },
        doRefuse(type){//拒收/取消拒收
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            let msg = '是否取消拒收？';
            if(type == 1){
                msg = '是否拒收该货物？';
            }else if(type == 2){
                msg = '是否将该货物转为现货？';
            }

            this.$confirm(msg, this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.inventoryIn.refused+'?t='+type, selectes.map(s => s.id))
                    .then((result) => {
                        this.$message(result.data);
                        if(result.status){
                            this.getData();
                        }
                    });
            }).catch((err) => {
                console.log(err);
            });
        },
    }
}

</script>

<style lang="scss" scoped>

.page-box{overflow-y:auto;}
.ctrl-box{position: absolute;z-index:99;width:100%;}
.empty-fixed-box{height:57.5px;}
.status-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.ctrl-item{
    display:block;
}
.ctrl-item::v-deep(.el-link--inner){
    display:flex;
    align-items: center;
}
</style>